import script from "./SwipeCarousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./SwipeCarousel.vue?vue&type=script&setup=true&lang=ts"

import "./SwipeCarousel.vue?vue&type=style&index=0&id=3948e991&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3948e991"]])

export default __exports__